import { MouseEvent, useEffect, useState } from "react";
import { Form, Spinner, Table } from "react-bootstrap";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import BarChart from "components/barChart";
import { FiArrowDownLeft, FiArrowUpRight } from "react-icons/fi";
import { HiOutlineEye } from "react-icons/hi";
import GraphShadowIcon from "components/graph-shadow-icon";
import "../../styles/subscription.css";
import ModalComponent from "components/modal-component";
import { AiOutlineClose } from "react-icons/ai";
import Logo from "../../assets/images/logo.svg";
import {
  DashboardQuery,
  SubCompanyPagination,
  SubscriptionCompany,
  SubscriptionPercentage,
  SubscriptionSummaryTotal,
} from "model/dashboardModel";
import {
  useGetSubscriptionCompanyQuery,
  useGetSubscriptionPercentageQuery,
} from "api/dashboardApi";
import { useDeleteCompanyMutation } from "api/config/externalApi";
import { FormattedDateTime } from "components/formatted-date";
import emptyFile from "../../assets/images/emptydata.gif";
import {
  showToastError,
  showToastSuccess,
} from "components/toastify/ToastNotifications";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import info from "../../assets/images/info.gif";
import { BaseUrl } from "api/baseUrl";
import { externalApi } from "api/config/externalApi";

type Props = {
  summaryData: any;
  customDate: any;
  refresh: boolean;
};

const SubscriptionSummary = ({ summaryData, customDate, refresh }: Props) => {
  const [loading, setLoading] = useState(false);
  const [smallLoading, setSmallLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [activityTab, setActivityTab] = useState("Subscribers");
  const [activePlan, setActivePlan] = useState("All");
  const [activeUser, setActiveUser] = useState("All");
  //Comment this out so that thdhdhd
  const [selectedCompany, setSelectedCompany] = useState<SubscriptionCompany>();
  const [show, setShow] = useState(false);
  const [smallShow, setSmallShow] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState("history");

  const [subSummaryTotal, setSubSummaryTotal] =
    useState<SubscriptionSummaryTotal>();

  // let query: DashboardQuery = {
  //   application: summaryData?.selectedPackage,
  //   periodFilter:
  //     summaryData?.subMenuSearch === "OneMonth" ||
  //     summaryData?.subMenuSearch === "ThreeMonths" ||
  //     summaryData?.subMenuSearch === "OneYear" ||
  //     summaryData?.subMenuSearch === "AllTime" ||
  //     summaryData?.subMenuSearch === "Custom"
  //       ? summaryData?.subMenuSearch
  //       : "AllTime",
  //   fromDate: customDate?.startDate,
  //   toDate: customDate?.endDate,
  // };

  const mapDuration = (raw?: string) => {
    if (!raw) return "AllTime";
    const v = raw.toString().trim().toLowerCase();

    // common UI inputs -> normalized
    if (["1 month", "1month", "one month", "onemonth", "1 m"].includes(v))
      return "OneMonth";
    if (
      ["3 months", "3months", "three months", "threemonths", "3 m"].includes(v)
    )
      return "ThreeMonths";
    if (
      [
        "12 months",
        "12months",
        "one year",
        "oneyear",
        "one-year",
        "12 m",
        "12 month",
      ].includes(v)
    )
      return "OneYear";
    if (["all time", "alltime", "all"].includes(v)) return "AllTime";
    if (v.includes("custom")) return "Custom";

    // accept already API-style inputs (case-insensitive)
    const noSpace = v.replace(/\s+/g, "");
    if (noSpace === "onemonth") return "OneMonth";
    if (noSpace === "threemonths") return "ThreeMonths";
    if (noSpace === "oneyear") return "OneYear";
    if (noSpace === "alltime") return "AllTime";
    if (noSpace === "custom") return "Custom";

    // fallback
    return "AllTime";
  };

  //   let query: DashboardQuery = {
  //   application: summaryData?.selectedPackage || "Joble", // fallback if needed
  //   periodFilter: durationMap[summaryData?.subMenuSearch || ""] || "AllTime",
  //   fromDate: customDate?.startDate,
  //   toDate: customDate?.endDate,
  // };
  let query: DashboardQuery = {
    application: "Joble", // fallback if needed
    // periodFilter: summaryData?.thirdValue,
    periodFilter: mapDuration(summaryData?.thirdValue),
    fromDate: customDate?.startDate,
    toDate: customDate?.endDate,
  };

  //Use the useGetAllTicketQuery hook with the query object
  // const { data: getSubSummary, error: getSubSummaryError, isFetching: getSubSummaryisFetching } = useGetSubscriptionSummaryQuery(query);

  // useEffect(() => {
  //     if (getSubSummaryisFetching) {
  //         setLoading(true);
  //     }
  //     else {
  //         setLoading(false);
  //         if (getSubSummaryError) {
  //             showToastError('Unable to fetch data from the server');
  //         }
  //         else {
  //             setSubSummaryTotal(getSubSummary?.data as SubscriptionSummaryTotal);
  //         }
  //     }
  // }, [getSubSummaryisFetching, summaryData]);

  const [subSummaryPercentage, setSubSummaryPercentage] =
    useState<SubscriptionPercentage>();
  const {
    data: getSubSummaryPercentage,
    error: getSubSummaryPercentageError,
    isFetching: getSubSummaryPercentageisFetching,
    refetch: getSubSummaryPercentageRefetching,
  } = useGetSubscriptionPercentageQuery(query);

  useEffect(() => {
    if (getSubSummaryPercentageisFetching) {
      setLoading(true);
    } else {
      setLoading(false);
      if (getSubSummaryPercentageError) {
        showToastError(
          `Unable to fetch data from the server, ${getSubCompanyError}`
        );
      } else {
        setSubSummaryPercentage(
          getSubSummaryPercentage?.data as SubscriptionPercentage
        );
      }
    }
  }, [getSubSummaryPercentageisFetching, summaryData, refresh]);

  const [pageNumber, setPageNumber] = useState<number>(1);

  const [queryParameters, setQueryParameters] = useState<DashboardQuery>({
    application: "joble",
    periodFilter: mapDuration(summaryData?.thirdValue),
    fromDate: customDate?.startDate,
    toDate: customDate?.endDate,
    page: pageNumber,
    pageSize: 10,
  });
  // 
  // let queryParameters: DashboardQuery = {
  //     application: summaryData?.selectedPackage,
  //     periodFilter: summaryData?.subMenuSearch === 'OneMonth' || summaryData?.subMenuSearch === 'ThreeMonths' || summaryData?.subMenuSearch === 'OneYear' || summaryData?.subMenuSearch === 'AllTime' || summaryData?.subMenuSearch === 'Custom' ? summaryData?.subMenuSearch : 'OneMonth',
  //     page: pageNumber,
  //     pageSize: 10,
  // };

  const [subCompanyPagination, setSubCompanyPagination] =
    useState<SubCompanyPagination>();
  const [subCompany, setSubCompany] = useState<SubscriptionCompany[]>([]);
  const [subCompanyFilter, setSubCompanyFilter] = useState<
    SubscriptionCompany[]
  >([]);
  const {
    data: getSubCompany,
    error: getSubCompanyError,
    isFetching: getSubCompanyisFetching,
    refetch: refetchSubCompany,
  } = useGetSubscriptionCompanyQuery(queryParameters);

  useEffect(() => {
    if (subCompanyPagination) {
      
      
      

      const totalPages =
        subCompanyPagination?.totalSize && subCompanyPagination?.pageSize
          ? Math.ceil(
              subCompanyPagination.totalSize / subCompanyPagination.pageSize
            )
          : 0;

      
    }
  }, [subCompany, subCompanyFilter, subCompanyPagination]);

  useEffect(() => {
    if (getSubCompanyisFetching) {
      setLoadingTable(true);
    } else {
      if (getSubCompanyError) {
        showToastError("Unable to fetch data from the server");
      } else {
        setSubCompanyPagination(getSubCompany?.data as SubCompanyPagination);
        setSubCompany(getSubCompany?.data?.items as SubscriptionCompany[]);
        setSubCompanyFilter(
          getSubCompany?.data?.items as SubscriptionCompany[]
        );
      }
      setLoadingTable(false);
    }
  }, [getSubCompanyisFetching, summaryData, refresh]);

  // Function to handle page change
  const onPageChange = async (page: number) => {
    setQueryParameters((prev) => ({ ...prev, page: page }));
    // You can perform actions like fetching data for the new page here
  };

  useEffect(() => {
    refetchSubCompany();
    getSubSummaryPercentageRefetching();
  }, [queryParameters?.page]);

  const products = ["BasicAccess", "FullAccess", "Enterprise"];

  const chartCountName =
    subSummaryPercentage &&
    subSummaryPercentage?.plans?.map((item) => item?.name);
  const chartSubCount =
    subSummaryPercentage &&
    subSummaryPercentage?.plans?.map((item) => item?.subscriptionCount);

  const subscription = {
    options: {
      chart: { id: "basic-bar", stacked: true },
      plotOptions: {
        bar: { borderRadius: 5, horizontal: true, barHeight: "50%" },
      },
      dataLabels: { enabled: false },
      xaxis: { categories: chartCountName || [0, 0, 0, 0] },
      yaxis: {
        show: true,
        labels: { show: true, minWidth: 80, maxWidth: 150 },
      },
      fill: { colors: ["#008CFE", "rgba(0, 140, 254, 0.15)"] },
      tooltip: { enabled: false },
    },
    series: [
      {
        name: "Active subscribers",
        data: chartSubCount || [0, 0, 0, 0],
        color: "#008CFE",
      },
      {
        name: "All time subscribers",
        data: chartSubCount || [0, 0, 0, 0],
        color: "rgba(0, 140, 254, 0.15)",
      },
    ],
    type: "bar",
    width: 500,
    height: 300,
  };

  const revenue = {
    options: {
      chart: { id: "basic-bar", stacked: true },
      plotOptions: {
        bar: { borderRadius: 5, horizontal: true, barHeight: "50%" },
      },
      dataLabels: { enabled: false },
      xaxis: { categories: chartCountName || [0, 0, 0, 0] },
      yaxis: {
        show: true,
        labels: { show: true, minWidth: 80, maxWidth: 150 },
      },
      fill: { colors: ["#21A600", "rgba(33, 150, 83, 0.1)"] },
      tooltip: { enabled: false },
    },
    series: [
      {
        name: "Projects created",
        data: chartSubCount || [0, 0, 0, 0],
        color: "#21A600",
      },
      {
        name: "Estimated Project creation",
        data: chartSubCount || [0, 0, 0, 0],
        color: "rgba(33, 150, 83, 0.1)",
      },
    ],
    type: "bar",
    width: 600,
    height: 300,
  };

  const handleFilter = (product: any) => {
    setActivePlan(product);
    if (product) {
      setSubCompanyFilter(
        subCompany?.filter((item) => item?.planName === product)
      );
    }
  };

  const [menuopen, setMenuopen] = useState<boolean>(false);
  const [selected, setSelected] = useState<any[]>([]);
  const addSelected = (val: any) => {
    const sel = selected || [];
    let k = sel.find((v) => v.email === val.email);
    k ? sel.splice(sel.indexOf(k), 1) : sel.push(val);
    setSelected(() => [...sel]);
    
  };

  async function handleDeleteCompany() {
    if (!selected.length) return; //nothing to delete
    try {
      setSmallLoading(true);
      for (const company of selected) {
        
        const response = await deleteComp(company.subdomain).unwrap();
        if ((response as any)?.ResponseMessage) {
          showToastSuccess((response as any).ResponseMessage);
        }
      }
      setSelected([]);
      refetchSubCompany();
      setSmallShow(false);
    } catch (error) {
      const err = error as any;
      if (err?.data?.ResponseMessage) {
        showToastError(err.data.ResponseMessage);
      } else if (err?.status === "FETCH_ERROR") {
        showToastError(
          "Failed to connect to server. Please check that your url is correct"
        );
      } else {
        showToastError(
          "An unexpected error occurred while deleting the company(ies)"
        );
      }
    } finally {
      setSmallLoading(false);
    }
  }

  const [deleteComp] = useDeleteCompanyMutation();

  const totalSubscriptions = subSummaryPercentage?.plans?.reduce(
    (sum, plan) => sum + plan.subscriptionCount,
    0
  );

  return (
    <div className="mt-4">
      <h5 className="fw-bold mb-4">
        {summaryData?.selectedPackage} Subscription Activity
      </h5>
      {loading ? (
        <div style={{ textAlign: "center", padding: "3rem", margin: "auto" }}>
          <Spinner />
          <br />
          <h4>loading...</h4>
        </div>
      ) : (
        <div style={{ display: "flex", gap: "1rem" }}>
          <div style={{ flex: 1, marginRight: "1rem" }}>
            {activityTab === "Subscribers" && (
              <div
                style={{
                  padding: "1.5rem 2rem",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "1.1rem", fontWeight: 500 }}>
                    {summaryData?.selectedPackage} Subscription Activity{" "}
                    <BiDotsHorizontalRounded />
                  </span>
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Form.Select
                      value={activityTab}
                      onChange={(e) => setActivityTab(e.target.value)}
                      style={{
                        width: "75%",
                        borderRadius: "50px",
                        padding: "0.25rem 0.5rem",
                      }}
                    >
                      <option value="Subscribers">Subscribers</option>
                      <option value="Revenue">Revenue</option>
                    </Form.Select>
                  </div>
                </div>
                <div className="d-flex align-items-end">
                  <h2 className="second-font">
                    {subSummaryPercentage?.totalCount?.toLocaleString()}
                  </h2>
                  <p className="dark-text ps-3">created so far</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <BarChart {...subscription} />
                </div>
              </div>
            )}

            {activityTab === "Revenue" && (
              <div
                style={{
                  padding: "1.5rem 2rem",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "1.1rem", fontWeight: 500 }}>
                    {summaryData?.selectedPackage} Revenue Activity{" "}
                    <BiDotsHorizontalRounded style={{ marginLeft: "1rem" }} />
                  </span>
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Form.Select
                      value={activityTab}
                      onChange={(e) => setActivityTab(e.target.value)}
                      style={{
                        width: "75%",
                        borderRadius: "50px",
                        padding: "0.25rem 0.5rem",
                      }}
                    >
                      <option value="Subscribers">Subscribers</option>
                      <option value="Revenue">Revenue</option>
                    </Form.Select>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    marginTop: "1rem",
                  }}
                >
                  <h2>
                    €{subSummaryPercentage?.totalRevenue?.toLocaleString()}
                  </h2>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <BarChart {...revenue} />
                </div>
              </div>
            )}
          </div>

          {/* Plans in a 2x2 Grid */}
          <div
            style={{
              flex: 1,
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gridAutoRows: "140px",
              gap: "1rem",
              alignItems: "start",
            }}
          >
            {subSummaryPercentage?.plans?.map((item, key) => {
              const borderColors = ["#F49F0A", "#008CFE", "#219653"];
              const borderColor =
                borderColors[Math.floor(Math.random() * borderColors.length)];
              return (
                <div
                  key={key}
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "0.6rem",
                    padding: "0.5rem 0.75rem", // smaller padding
                    display: "flex",
                    justifyContent: "space-between",
                    height: "140px", // keep fixed height
                    borderLeft: `6px solid ${borderColor}`,
                    boxSizing: "border-box",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center", // center content vertically
                      gap: "0.12rem",
                      minWidth: 0,
                    }}
                  >
                    <span
                      style={{
                        fontSize: "1.02rem",
                        fontWeight: 500,
                        margin: 0,
                        lineHeight: 1,
                      }}
                    >
                      {item?.name} Plan
                    </span>
                    <h2 style={{ margin: "0.12rem 0", lineHeight: 1.1 }}>
                      {item?.subscriptionCount}
                    </h2>
                    <span
                      style={{
                        color:
                          item?.percentageIncrement >= 0
                            ? "#219653"
                            : "#EB5757",
                        display: "flex",
                        alignItems: "center",
                        margin: 0,
                        lineHeight: 1,
                      }}
                    >
                      {item?.percentageIncrement >= 0 ? (
                        <FiArrowUpRight
                          size={18}
                          style={{ marginRight: "0.4rem" }}
                        />
                      ) : (
                        <FiArrowDownLeft
                          size={18}
                          style={{ marginRight: "0.4rem" }}
                        />
                      )}
                      {parseFloat(item?.percentageIncrement.toFixed(0))}% last
                      month
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "0.5rem",
                    }}
                  >
                    {item?.percentageIncrement >= 0 ? (
                      <GraphShadowIcon fillColor="#219653" />
                    ) : (
                      <GraphShadowIcon fillColor="#EB5757" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="my-4">
        <h6 className="first-font-medium">
          {summaryData?.selectedPackage} Subscription Summary
        </h6>
        {loadingTable ? (
          <div className="text-center p-5 m-auto">
            <Spinner />
            <br /> <h4>loading...</h4>
          </div>
        ) : (
          <>
            <div className="my-4 position-relative">
              <button
                onClick={() => {
                  setSubCompanyFilter(subCompany);
                  setActivePlan("All");
                }}
                className={
                  activePlan === "All"
                    ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3"
                    : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3"
                }
              >
                All Plans
              </button>
              {products?.map((product) => (
                <button
                  onClick={() => handleFilter(product)}
                  className={
                    activePlan === product
                      ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3"
                      : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3"
                  }
                >
                  {product}
                </button>
              ))}
              {selected.length ? (
                <div className="position-absolute end-0 top-0">
                  <button
                    className="btn-primary font-size-sm first-font-medium"
                    onClick={() => setMenuopen(!menuopen)}
                  >
                    Manage Client
                  </button>
                  {menuopen ? (
                    <div
                      className="bg-white shadow-sm rounded-2 position-absolute mt-2"
                      style={{ width: "14em" }}
                    >
                      <div
                        className="d-flex align-items-center p-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSmallShow(true);
                          setActiveModalTab("delete");
                          setMenuopen(false);
                        }}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.3034 14.3034C15.7099 12.8968 16.5001 10.9892 16.5001 9.00005C16.5001 7.01091 15.7099 5.10324 14.3034 3.69671C12.8968 2.29018 10.9892 1.5 9.00005 1.5C7.01091 1.5 5.10324 2.29018 3.69671 3.69671M14.3034 14.3034C12.8968 15.7099 10.9892 16.5001 9.00005 16.5001C7.01091 16.5001 5.10324 15.7099 3.69671 14.3034C2.29018 12.8968 1.5 10.9892 1.5 9.00005C1.5 7.01091 2.29018 5.10324 3.69671 3.69671M14.3034 14.3034L3.69671 3.69671"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>{" "}
                        &nbsp; Delete Accounts
                      </div>
                      <div
                        className="d-flex align-items-center p-2"
                        style={{ cursor: "pointer" }}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.125 5.625V14.375C18.125 14.8723 17.9275 15.3492 17.5758 15.7008C17.2242 16.0525 16.7473 16.25 16.25 16.25H3.75C3.25272 16.25 2.77581 16.0525 2.42417 15.7008C2.07254 15.3492 1.875 14.8723 1.875 14.375V5.625M18.125 5.625C18.125 5.12772 17.9275 4.65081 17.5758 4.29917C17.2242 3.94754 16.7473 3.75 16.25 3.75H3.75C3.25272 3.75 2.77581 3.94754 2.42417 4.29917C2.07254 4.65081 1.875 5.12772 1.875 5.625M18.125 5.625V5.8275C18.125 6.14762 18.0431 6.46242 17.887 6.74191C17.7309 7.0214 17.5059 7.25628 17.2333 7.42417L10.9833 11.27C10.6877 11.4521 10.3472 11.5485 10 11.5485C9.65275 11.5485 9.31233 11.4521 9.01667 11.27L2.76667 7.425C2.4941 7.25711 2.26906 7.02224 2.11297 6.74275C1.95689 6.46325 1.87496 6.14845 1.875 5.82833V5.625"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>{" "}
                        &nbsp; Send Update/Message
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>

            {subCompany?.length > 0 ? (
              <>
                <Table responsive className="table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>
                        <label className="fw-normal">SN</label>
                      </th>
                      <th>
                        <label className="fw-normal">Company Name</label>
                      </th>
                      <th>
                        <label className="fw-normal">Country</label>
                      </th>
                      <th>
                        <label className="fw-normal">Email</label>
                      </th>
                      <th>
                        <label className="fw-normal">Plan</label>
                      </th>
                      {/* <th>
                                    <span className='font-size-12 text-secondary py-2'>Staff Size</span>
                                </th> */}
                      <th>
                        <label className="fw-normal">Registration Date</label>
                      </th>
                      <th>
                        <label className="fw-normal">Action</label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {subCompanyFilter?.map((item, key) => (
                      <tr key={key} className="align-middle">
                        <td>
                          <Form.Check onClick={() => addSelected(item)} />
                        </td>
                        <td>
                          {((subCompanyPagination?.pageNumber || 1) - 1) *
                            (subCompanyPagination?.pageSize || 10) +
                            key +
                            1}
                        </td>
                        <td>{item?.companyName}</td>
                        <td>
                          <span className="text-secondary">
                            {item?.country}
                          </span>
                        </td>
                        <td>
                          <span className="text-secondary">{item?.email}</span>
                        </td>
                        <td>
                          <span className="text-secondary">
                            {item?.planName}
                          </span>
                        </td>
                        {/* <td><span className='text-secondary'>{item?.staffSize}</span></td> */}
                        <td>
                          <span className="text-secondary">
                            {FormattedDateTime(item?.registrationDate)}
                          </span>
                        </td>
                        <td>
                          <button
                            onClick={() => {
                              setSelectedCompany(item);
                              setShow(true);
                              setActiveModalTab("history");
                            }}
                            className="btn btn-transparent px-0 mx-0 py-2 rounded-3"
                          >
                            <HiOutlineEye size={15} className="primary-text" />{" "}
                            View Subscription History
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="text-end py-3">
                  <Pagination
                    current={subCompanyPagination?.pageNumber || 0}
                    total={subCompanyPagination?.totalSize}
                    pageSize={subCompanyPagination?.pageSize}
                    onChange={onPageChange}
                  />
                </div>
              </>
            ) : (
              <div className="p-5 text-center fs-5">
                <img src={emptyFile} width="200px" />
                <h6>No data available</h6>
              </div>
            )}
          </>
        )}
      </div>
      <ModalComponent
        size={undefined}
        showModal={smallShow}
        hideModal={() => setSmallShow(false)}
      >
        {activeModalTab === "delete" && (
          <div className="px-3">
            <div className="my-3 text-center">
              <img src={info} width="120px" />
            </div>
            <p className="fs-5 fw-bold">
              Confirm deletion of selected Company(ies)
            </p>
            <p className="text-secondary">
              Are you sure you want to delete the selected company(ies)? <br />
              Removing this company(ies) would remove all access and history on
              JobPro.
            </p>
            <div className="pt-3 pb-4">
              <button
                disabled={loading}
                type="button"
                onClick={() => handleDeleteCompany()}
                className="btn btn-danger w-100 border-0 py-3 rounded-5"
              >
                Confirm {smallLoading && <Spinner size="sm" />}
              </button>
            </div>
          </div>
        )}
      </ModalComponent>

      <ModalComponent
        size="xl"
        showModal={show}
        hideModal={() => setShow(false)}
      >
        <div className="position-absolute w-100 p-3 mb-5">
          <p className="d-flex justify-content-end pb-4">
            <button className="btn p-0 ">
              <AiOutlineClose onClick={() => setShow(false)} size={20} />
            </button>
          </p>
        </div>
        <div className="px-4 py-5">
          <div className="mt-3 mb-5">
            <span className="bg-white p-3 rounded-3">
              <img src={Logo} />
            </span>
          </div>
          {/* <div className='d-flex justify-content-between px-4 py-5'>
                        <div>
                            <button onClick={() => setActiveUser("All")} className={activeUser === "All" ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3 py-2" : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3 py-2"}>All Users</button>
                            <button onClick={() => setActiveUser("Deactivated")} className={activeUser === "Deactivated" ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3 py-2" : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3 py-2"}>Deactivated Employees</button>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <button onClick={() => setActiveUser("All")} className="btn-primary font-size-sm first-font-medium px-3 me-3 py-2"><FiPlus size={20} /> Invite Employee</button>
                            <button onClick={() => setActiveUser("Deactivated")} className="btn-secondary-outline font-size-sm first-font-medium px-3 me-3 py-2"><GoCircleSlash size={20} /> Suspend Employee</button>
                            <Form className='my-auto'>
                                <Form.Control type='text' placeholder='Search' className='rounded-4 search-input light-text' />
                            </Form>
                        </div>
                    </div> */}

          {activeModalTab === "history" && (
            <div>
              <Table responsive className="table">
                <thead>
                  <tr>
                    <th>
                      <label className="fw-normal">SN</label>
                    </th>
                    <th>
                      <label className="fw-normal">Company Name</label>
                    </th>
                    <th>
                      <label className="fw-normal">Country</label>
                    </th>
                    <th>
                      <label className="fw-normal">Email</label>
                    </th>
                    <th>
                      <label className="fw-normal">Plan</label>
                    </th>
                    <th>
                      <label className="fw-normal">Registration Date</label>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="align-middle">
                    <td>
                      <Form.Check />
                    </td>
                    <td>{selectedCompany?.companyName}</td>
                    <td>
                      <span className="text-secondary">
                        {selectedCompany?.country}
                      </span>
                    </td>
                    <td>
                      <span className="text-secondary">
                        {selectedCompany?.email}
                      </span>
                    </td>
                    <td>
                      <span className="text-secondary">
                        {selectedCompany?.planName}
                      </span>
                    </td>
                    {/* <td><span className='text-secondary'>{selectedCompany?.staffSize}</span></td> */}
                    <td>
                      <span className="text-secondary">
                        {FormattedDateTime(
                          selectedCompany?.registrationDate || ""
                        )}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </ModalComponent>
    </div>
  );
};

export default SubscriptionSummary;

